import { request } from '@/utils/request'

/**
 * 图片地址转base64
 *
 * @param {Object} data 参数
 * @param {String} data.url 图片地址
 * @returns {Promise} 异步数据
 */
export async function imgUrlToBase64 (data) {
  const { url } = data
  if (!url) {
    return
  }
  if (url.startsWith('data:image/')) {
    return url
  }
  let ext = url.split('.').pop().split('?')?.[0] ?? 'jpeg'
  ext = ext === 'jpg' ? 'jpeg' : ext
  const res = await request.post(process.env.VUE_APP_BASE64_IMG_URL, data)
  return `data:image/${ext};base64,${res.data}`
}

export const loadImg = imgUrl => {
  return new Promise((resolve, reject) => {
    if (!imgUrl) {
      const errMsg = '请传入正确的图片链接'
      reject(errMsg)
      return
    }
    const img = new Image()
    img.src = imgUrl
    img.onload = () => {
      resolve(img)
      console.log(img)
    }
    img.onerror = () => {
      const errMsg = `图片加载失败#${imgUrl}`
      reject(errMsg)
    }
  })
}
